import dayjs from "dayjs"
import utc from "dayjs/plugin/utc";
import moment from 'moment'

export const queryFromObj = (p: any) => {
    let q = ""
    for (const key in p) {
        let prePend = "&"
        if (q.length == 0) {
            prePend = "?"
        }
        if (!!p[key]) {
            q += `${prePend}${key}=${p[key]}`
        }
    }
    return q
}

export const removeEmpty = (p: any) => {
    for (const key in p) {
        if (!!!p[key]) {
            delete p[key]
        }
    }
    return p
}


enum TargetTable {
    Transaction = "transactionPK"
}

type CreatQueryProps = {
    range: {
        fromDate: string
        toDate: string
    },
    filter: any
    limit: number
    lastTransactionID?: string
    sort?: string
}


export const createTransactionQuery = (params: CreatQueryProps) => {
    let filter = `$and(`;

    filter += `transactionPK.transactionDateTime:gt:${params.range.fromDate},`
    filter += `transactionPK.transactionDateTime:lt:${params.range.toDate},`

    if (!!params.filter) {
        for (const key in params.filter) {
            filter += `${key}:${params.filter[key]},`
        }
    }

    filter += ")"

    let sort = `|sort(transactionPK.transactionDateTime#desc,`;

    if (!!params.sort) {
        // let sort = `|sort(`;
        sort += params.sort + ","
    }

    sort += ')'

    filter += sort

    filter += `|limit#${params.limit}`

    if (!!params.lastTransactionID) {
        filter += `|next(transactionPK.transactionId:${params.lastTransactionID})`
    }

    return filter

}


export const DisputedTransactionQuery = (params: CreatQueryProps) => {
    let filter = `$and(`;

    filter += `transaction.transactionPK.transactionDateTime:gt:${params.range.fromDate},`
    filter += `transaction.transactionPK.transactionDateTime:lt:${params.range.toDate},`

    if (!!params.filter) {
        for (const key in params.filter) {
            filter += `${key}:${params.filter[key]},`
        }
    }

    filter += ")"

    let sort = `|sort(transaction.transactionPK.transactionId#desc,`;

    if (!!params.sort) {
        // let sort = `|sort(`;
        sort += params.sort + ","
    }

    sort += ')'

    filter += sort

    filter += `|limit#${params.limit}`

    if (!!params.lastTransactionID) {
        filter += `|next(transaction.transactionPK.transactionId:${params.lastTransactionID})`
    }

    return filter

}


export const SimpleTransactionSearchQuery = (params: {
    transactionId: string,
    vehicleRegistrationNumber: string
}) => {
    let filter = `$and(`
    if (!!params.transactionId) {
        filter += `transactionPK.transactionId:eq:${params.transactionId},`
    }
    if (!!params.vehicleRegistrationNumber) {
        filter += `vehicleRegistrationNumber:eq:${params.vehicleRegistrationNumber},`
    }
    filter += `)`
    return filter;
}

type AmountProps = {
    amount?: number | string | null
}

export const AmountFormate = ({ amount }: AmountProps) => {
    if (amount === undefined || amount === null || amount === "") {
        return ""
    }

    if (typeof amount === "number") {
        return amount.toLocaleString("en-IN")
    }

    if (typeof amount === "string") {
        const cleaned = amount.replace(/,/g, "").trim()
        const num = Number(cleaned)

        if (isNaN(num)) {
            return amount
        }

        return num.toLocaleString("en-IN")
    }

    return ""
}



export const DateRangeOnlyDate = (range: any) => {
    const now = dayjs();
    const format = "YYYY-MM-DD";

    switch (range) {
        case "day":
            return {
                start: now.format(format),
                end: now.format(format),
            };

        case "week":
            return {
                start: now.subtract(7, "day").format(format),
                end: now.format(format),
            };

        case "month":
            return {
                start: now.subtract(30, "day").format(format),
                end: now.format(format),
            };

        case "4weeks":
            return {
                start: now.subtract(28, "day").format(format),
                end: now.format(format),
            };

        case "8weeks":
            return {
                start: now.subtract(56, "day").format(format),
                end: now.format(format),
            };

        default:
            return {
                start: now.format(format),
                end: now.format(format),
            };
    }
};




export const DateRange = (range: any) => {
    const now = dayjs();
    const format = "YYYY-MM-DDTHH:mm:ss";

    switch (range) {
        case "day":
            return {
                start: now.subtract(24, "hour").format(format),
                end: now.format(format),
            };

        case "week":
            return {
                start: now.subtract(7, "day").format(format),
                end: now.format(format),
            };

        case "month":
            return {
                start: now.subtract(30, "day").format(format),
                end: now.format(format),
            };

        case "4weeks":
            return {
                start: now.subtract(28, "day").format(format),
                end: now.format(format),
            };

        case "8weeks":
            return {
                start: now.subtract(56, "day").format(format),
                end: now.format(format),
            };

        default:
            return {
                start: now.format(format),
                end: now.format(format),
            };
    }
};





export const ErrorBlobConverter = async (errorBlob: Blob, error?: any) => {
    if (errorBlob?.type === 'application/json') {
        const text = await errorBlob.text();
        const errorJson = JSON.parse(text);
        return errorJson?.errors
            ?.map((e: any) => e.message)
            .join(', ') || 'Something went wrong';
    }

    return error?.message || 'Unexpected error';
};







export const CycleThroughValue = (obj: any, cb: (key: string, value: any) => any): any => {
    switch (typeof obj) {
        case "object":
            if (typeof obj.length != "undefined") {
                // array
                for (let i = 0; i < obj.length; i++) {
                    const el = obj[i];
                    obj[i] = CycleThroughValue(el, cb)
                }
            } else {
                // object
                for (const k in obj) {
                    if (!Object.hasOwn(obj, k)) continue;
                    const el = obj[k];
                    if (typeof el == "string") {
                        obj[k] = cb(k, el)
                    } else {
                        obj[k] = CycleThroughValue(el, cb)
                    }
                }
            }
            return obj
        default:
            return obj
    }
}



export const TodayValue = (arr: any[], cb: (val: any) => any) => {

    let values: any[] = [
       [],
       [],
       []
    ];

    [...arr]
        .sort((x, y) => dayjs(x).diff(dayjs(y)) ? -1 : 1)
        .forEach(el => {

            let elValue = dayjs(cb(el))

            let startOfDay = dayjs().startOf("day");
            let endOfFirstHalf = dayjs().startOf("day").add(8,"hour")
            let endOfSecondHalf = dayjs().startOf("day").add(16,"hour")
            let endOfDay = dayjs().endOf("day");

            if (startOfDay.isBefore(elValue) && endOfFirstHalf.isAfter(elValue)) {
                values[0].push(el)
            }

            if (endOfFirstHalf.isBefore(elValue) && endOfSecondHalf.isAfter(elValue)) {
                values[1].push(el)
            }

            if (endOfSecondHalf.isBefore(elValue) && endOfDay.isAfter(elValue)) {
                values[2].push(el)
            }

        })

    return values;
}

export const GroupByTime = (arr: any[], hours: number, cb: (val: any) => any) => {
    let lhs = 0;
    let rhs = hours;

    let vals: any = {};

    [...arr]
        .sort((x, y) => moment(x) > moment(y) ? -1 : 1)
        .forEach(el => {
            let dif = moment().endOf("day").diff(cb(el), "hours")
            let diff = 24 - dif
            if (diff > lhs && diff <= rhs) {
                if (typeof vals[lhs] == "undefined") {
                    vals[lhs] = []
                }
                vals[lhs].push(el)
            } else {
                lhs += hours
                rhs += hours
                vals[lhs] = [el]
            }
        });
    let values = []
    for (const key in vals) {
        if (!Object.hasOwn(vals, key)) continue;
        const element = vals[key];
        values.push(element)
    }
    return values
}



export const GroupByDays = (arr: any[], totalDaysFromToday: number, filterCB: (val: any, keyDay: any) => boolean, emptyValue: any) => {

    let vals: any = {};

    for (let i = 0; i < totalDaysFromToday; i++) {
        let key = dayjs().subtract(i, "day").format("YYYY-MM-DD")
        let val = [...arr].find((e) => filterCB(e, key))
        vals[key] = !!val ? { ...val, date: key } : { ...emptyValue, date: key }
    }

    return Object.values(vals)
}

export const GroupByWeek = (arr: any[], weeks: number, filterCB: (val: any, keyDay: any) => boolean, sortCB: (x: any, y: any) => number, emptyValue: any, cbForDate: (val: any) => any) => {
    let totalDays = weeks * 7

    let mapDates = GroupByDays(arr, totalDays, filterCB, emptyValue)
        .sort(sortCB)

    let group: any = [];

    new Array(weeks)
        .fill("0")
        .map((_, i) => dayjs().subtract(i * 7, "day").format("YYYY-MM-DD"))
        .map((key) => {
            group.push({ date: key, values: [] })
        })

    let sortedGroup = group
        .sort((x: any, y: any) => dayjs(x.date).diff(dayjs(y.date)) > 0 ? 1 : -1)
        .map((e: any) => {
            let rhs = dayjs(e.date);
            let lhs = dayjs(e.date).subtract(7, "day");

            let arrList = mapDates.filter((el) => {
                let lhsv = dayjs(cbForDate(el)).diff(lhs)
                let rhsv = dayjs(cbForDate(el)).diff(rhs)
                return lhsv > 0 && rhsv <= 0
            })

            return { ...e, values: arrList }

        })

    return sortedGroup
}

dayjs.extend(utc);
export default dayjs;

export const DateFormate = (e: any) => {
    let val = dayjs.utc(e)
        .add(5, "hour")
        .add(30, "minute")
        .format("DD/MM/YYYY HH:mm:ss");

    return val;
};
